import { useQuery } from "@tanstack/react-query";

import { useOrganization } from "@/hooks/useOrganization";
import { supabase } from "@/integrations/supabase/client";

export function useSchoolsEntitlement(): {
  enabled: boolean;
  isLoading: boolean;
} {
  const { organizationId, isLoading: organizationLoading } = useOrganization();

  const query = useQuery({
    queryKey: ["schools", "entitlement", organizationId],
    queryFn: async () => {
      if (!organizationId) return false;
      const { data, error } = await supabase.rpc("school_has_schools_entitlement" as never, {
        _org_id: organizationId,
      } as never);
      if (error) throw error;
      return data === true;
    },
    enabled: Boolean(organizationId) && !organizationLoading,
    staleTime: 5 * 60_000,
  });

  const isLoading = organizationLoading || query.isLoading;

  return {
    enabled: !isLoading && !query.error && query.data === true,
    isLoading,
  };
}

export const useSchoolsPreschoolEntitlement = useSchoolsEntitlement;
